import { apiFields } from "./_utils";
import { getFeatureToggles } from "js/api/featureTogglesApi";
import useStore from ".";
import { getFeatures } from "./classwizeConfigStore";

export const createFeatureTogglesStore = (set, get, api, setIn) => ({
	...apiFields(),
	data: {},

	fetch: async () => {
		setIn({ isFetching: true });
		const data = await getFeatureToggles();

		//Add local storage toggles
		Object.keys(localStorage).forEach((key) => {
			if (localStorage.getItem(key) === "true" || localStorage.getItem(key) === "false") {
				data[key] = localStorage.getItem(key) === "true";
			}
		});

		setIn({ data, isFetching: false, lastFetched: Date.now() });
	},

	isNativeAppControlsEnabled: () => getFeatures(useStore.getState()).includes("native_app_controls"),
});

export const getFeatureFlags = (state) => state.featureToggles.data;
